import React from 'react'


import card_bill from '../../Contents/images/utils/card-bill.jpg'
import phone_bill from '../../Contents/images/utils/phone-bill.jpg'
import school_bill from '../../Contents/images/utils/school-bill.jpg'
import mortgage_bill from '../../Contents/images/utils/mortgage-bill.jpg'
import energy_bill from '../../Contents/images/utils/energy-bill.jpg'
import gas_bill from '../../Contents/images/utils/gas-bill.jpeg'
import insurance_bill from '../../Contents/images/utils/insurance-bill.jpg'
import loan_servicing from '../../Contents/images/utils/loan-servicing.webp'
import { GiPayMoney } from 'react-icons/gi'
import { useStateValue } from '../../Utils/StateProvider'

const Bills = () => {
    const [{}, payload] = useStateValue()
    return (
        <div className='display'>
            <div className="bill-container">
                <h1>Gain control. Stay in control.</h1>
                <p>
                    you can view, track and pay all your bills in one secure place, with one password.
                </p>
                <ul className='bills'>
                    <li>
                        <img src={card_bill} alt="Card Bills" />
                        <div className="bill-box">
                            <h3>Credit Card Bills</h3>
                            <p>
                                Ease your financial burden with hassle-free credit card bill payment.
                            </p>
                            <div className="btn-screen">
                                <button onClick={() => payload({ type: 'SET_NOTIFY', data: { text: 'Pay bill has not been enabled on this account. For further assistance please contact support', type: 'warn'}})}>Pay <GiPayMoney /></button>
                            </div>
                        </div>
                    </li>
                    <li>
                        <img src={phone_bill} alt="Phone Bills" />
                        <div className="bill-box">
                            <h3>Phone Bills</h3>
                            <p>
                                Stay connected without worries - pay your phone bill on time.
                            </p>
                            <div className="btn-screen">
                                <button onClick={() => payload({ type: 'SET_NOTIFY', data: { text: 'Pay bill has not been enabled on this account. For further assistance please contact support', type: 'warn'}})}>Pay <GiPayMoney /></button>
                            </div>
                        </div>
                    </li>
                    <li>
                        <img src={school_bill} alt="Loan Servicing" />
                        <div className="bill-box">
                            <h3>School Bills</h3>
                            <p>
                                Simplify life with easy and secure online payment options, and give yourself and loved ones the best possible start in life.
                            </p>
                            <div className="btn-screen">
                                <button onClick={() => payload({ type: 'SET_NOTIFY', data: { text: 'Pay bill has not been enabled on this account. For further assistance please contact support', type: 'warn'}})}>Pay <GiPayMoney /></button>
                            </div>
                        </div>
                    </li>
                    <li>
                        <img src={energy_bill} alt="Energy Bills" />
                        <div className="bill-box">
                            <h3>Energy Bills</h3>
                            <p>
                                Keep the lights on and save time with energy bill payment.
                            </p>
                            <div className="btn-screen">
                                <button onClick={() => payload({ type: 'SET_NOTIFY', data: { text: 'Pay bill has not been enabled on this account. For further assistance please contact support', type: 'warn'}})}>Pay <GiPayMoney /></button>
                            </div>
                        </div>
                    </li>
                    <li>
                        <img src={gas_bill} alt="Gas Bills" />
                        <div className="bill-box">
                            <h3>Gas Bills</h3>
                            <p>
                                Never run out of gas - pay your bill from anywhere, anytime.
                            </p>
                            <div className="btn-screen">
                                <button onClick={() => payload({ type: 'SET_NOTIFY', data: { text: 'Pay bill has not been enabled on this account. For further assistance please contact support', type: 'warn'}})}>Pay <GiPayMoney /></button>
                            </div>
                        </div>
                    </li>
                    <li>
                        <img src={mortgage_bill} alt="Mortgage Bills" />
                        <div className="bill-box">
                            <h3>Mortgage Bills</h3>
                            <p>
                                Secure your home with mortgage bill payment, and enjoy peace of mind.
                            </p>
                            <div className="btn-screen">
                                <button onClick={() => payload({ type: 'SET_NOTIFY', data: { text: 'Pay bill has not been enabled on this account. For further assistance please contact support', type: 'warn'}})}>Pay <GiPayMoney /></button>
                            </div>
                        </div>
                    </li>
                    <li>
                        <img src={insurance_bill} alt="Insurance Bills" />
                        <div className="bill-box">
                            <h3>Insurance Bills</h3>
                            <p>
                                Protect what matters most with timely insurance bill payment.
                            </p>
                            <div className="btn-screen">
                                <button onClick={() => payload({ type: 'SET_NOTIFY', data: { text: 'Pay bill has not been enabled on this account. For further assistance please contact support', type: 'warn'}})}>Pay <GiPayMoney /></button>
                            </div>
                        </div>
                    </li>
                    <li>
                        <img src={loan_servicing} alt="Loan Servicing" />
                        <div className="bill-box">
                            <h3>Loan Servicing</h3>
                            <p>
                                Manage your debt effectively with stress-free loan servicing.
                            </p>
                            <div className="btn-screen">
                                <button onClick={() => payload({ type: 'SET_NOTIFY', data: { text: 'Pay bill has not been enabled on this account. For further assistance please contact support', type: 'warn'}})}>Pay <GiPayMoney /></button>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default Bills
